
import { NotificationManager } from 'react-notifications';

export const createNotification = (type: string, message: string) => {
    switch (type) {
        case 'info':
            NotificationManager.info(message);
            break;
        case 'success':
            NotificationManager.success(message, null, 3000);
            break;
        case 'warning':
            NotificationManager.warning(message);
            break;
        case 'error':
            NotificationManager.error(message);
            break;
        default:
            NotificationManager.info(message);
    }
};